import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

import Header from '@/components/Header'
import Editor from '@/components/editor'
import Export from '@/components/export'
import Users from '@/components/users'
import Player from '@/components/Player'
import Show from '@/components/Show'
import Project from '@/components/project'
import Login from '@/components/login'
import ChangePassword from '@/components/changePassword'
import Translate from '@/components/translate'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', component: Login },
    {
      path: '/editor',
      name: 'editor',
      components: {
        default: Editor,
        header: Header
      },
      beforeEnter: (to, from, next) => {
        store.commit('resetSelection')
        next()
      }
    },
    {
      path: '/project',
      name: 'project',

      components: {
        default: Project,
        header: Header
      }
    },
    {
      path: '/player',
      name: 'player',

      components: {
        default: Player,
        header: Header
      }
    },
    {
      path: '/show',
      name: 'show',
      
      components: {
        default: Show,
        header: Header
      }
    },
    {
      path: '/export',
      name: 'export',

      components: {
        default: Export,
        header: Header
      }
    },
    {
      path: '/users',
      name: 'users',

      components: {
        default: Users,
        header: Header
      }
    },
    {
      path: '/translate',
      name: 'translate',

      components: {
        default: Translate,
        header: Header
      }
    },
    {
      path: '/login',
      name: 'login',

      components: {
        default: Login,
        header: Header
      }
    },
    {
      path: '/changePassword',
      name: 'changePassword',

      components: {
        default: ChangePassword,
        header: Header
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path !== "/login" && !store.getters.isAuthenticated) {
    next({
      path: '/login'
    });
  } else {
    next()
  }
})

export default router


